import React from 'react'
import CourseClassNews from './CourseClassNews'

const CourseClassNewsTab = () => (
  <div className="flex flex-col items-start space-y-6">
    <CourseClassNews />
  </div>
)

export default CourseClassNewsTab
